
  import TiwiMixin from '../mixins/TiwiMixin';
  import RemoteApiService from '../services/remote_api';
  import _ from 'lodash';
  import axios from 'axios';
  
  export default {
    mixins: [TiwiMixin],
    props: {
      kitId: {
        type: Number,
        required: true,
      },
      remoteApiUrl: {
        type: String,
        default: 'https://desk.communiti.it/api/'
      },
      remoteToken: {
        type: String,
        required: false,
      },
      remoteId: {
        type: String,
        required: false,
      },
      legacyApiUrl: {
        type: String,
        //default: 'https://api.progettieducativi.it/api/v3/'
        default: 'https://colibri-api-v3.site-dev.it/api/v3/'
        
      },
      legacySchoolsApiUrl: {
        type: String,
        default: 'https://v2.api.progettieducativi.it/api/v2/'
      },
      legacyLocationsApiUrl: {
        type: String,
        default: 'https://locations-api.dev.progettieducativi.it/api/v1/'
      },
      resultCta:{
        type: Object,
        default: null,
        required: false
      },



      privacy_policy_content: {
        type: String,
        default: 'Informativa d.lgs 196/2003 - Librì Progetti Educativi S.r.l., titolare del trattamento, si impegna a trattare con riservatezza i dati che Lei inserirà nel presente coupon al fine di inviare il materiale didattico da lei richiesto e relative informative destinate alla corretta e completa fruizione dei materiali e dei servizi ad esso collegati, quali, a titolo esemplificativo: Invio materiali didattici, Concorsi, Webinar, Crediti formativi, Riconferme annuali, Invio elaborati delle classi, Newsletter per la prenotazione di materiali didattici.I dati personali da Lei forniti saranno trattati anche con l’ausilio di mezzi elettronici, direttamente da Librì Progetti Educativi srl. Il conferimento dei dati personali è obbligatorio per le finalità di cui sopra, per il corretto adempimento degli obblighi di legge; pertanto, un eventuale rifiuto in merito rende impossibile lo svolgimento del servizio richiesto. Ai sensi dell’articolo 7 del D. Lgs. 196/2003, potrà sempre verificare i Suoi dati, aggiornarli, modificarli, integrarli, cancellarli e opporsi all’invio di messaggi rivolgendosi a: Librì Progetti Educativi S.r.l., Piazza degli Scarlatti, 2r 50125 Firenze – nella persona dell’Amministratore Delegato.'
      },
      privacy_policy_url: {
        type: String,
        default: 'https://www.iubenda.com/privacy-policy/68797005'
      },
    },
    data() {
      return {
        max_students_per_class: 50,
        current_step: 0,
        current_auth_state: 'start', // login | register
        current_alert: null,
        reset_password_confirmation: false,

        show_password: false,


        user_found: null,


        form_config: {},



        // contenuto dei form

        form_login: {
          email: '',
          password: '',
        },
        form_register: {
          first_name: '',
          last_name: '',
          nickname: '',
          role_id: null,
          email: '',
          phone: '',
          password: '',
          // password_confirmation: '',
          privacy_acceptance: false,
          marketing_acceptance: false,
        },

        form_school:{
          name: '',
          address: '',
          district: '',
          city: '',
          zip_code: '',
          email: '',
          phone: '',
          school_manager: '',

        },

        form_validation:{
          type: null,
          success: null,
          errors: []

        },


        // step 0
        current_user: null,
        current_teaching_area: 'UNDEFINED',

        // step 1 - tranne form

        schools_found: [],
        school_search_string: '',
        school_form_enabled: false,
        school_districts: [],
        school_cities: [],

        current_school: null,
        school_provinces: [],
        school_cities: [],


        // step 2
        class_sections: ['A','B','C','D','E','F','G','H','I','L','M','N','O','P','Q','R','S','T','U','V','Z'],
        class_types: [],
        class_groups: [],

        current_classes: [],



        // step 3
        privacy_accepted: false,


        // KIT DATA
        kit: null,

        // ORDER CLOSE
        

        order_result: {
          id : null,
          data : {},
          items: [],
          completed: false,
        }


        
      }
    },
    mounted: function(){
      this.remote_api = new RemoteApiService( this.remoteApiUrl, this.remoteId, this.remoteToken );

      this.getKitOrderConfig();
      this.getKitData();
      this.userCheck();
      this.getSchoolTypes();
      this.getLocationOptions();
      this.addClass();


    },
    methods: {

      handleAlert: function( err, type ){
        // alert( message ? message : err );

        if( !type )
          type = 'danger';

        this.current_alert = err;
        this.current_alert_type = type;
      },


      gotoStep: function( step ){
        this.current_step = step;
        window.location.hash = 'step-' + step;
      },

      checkMaxStudents: function(c){
        if( parseInt(c.students_count) > this.max_students_per_class ){
          c.students_count = this.max_students_per_class;
          alert('Attenzione: il numero massimo di alunni per classe è ' + this.max_students_per_class) ;
        }
      },



      getKitOrderConfig: function(){

        var self = this;

        self.setLoading(true);

        this.remote_api.client.get('/user/kit-order-config/' + this.kitId)
        .then( (response) => {
          if( response.data.success && response.data.config )
            self.form_config = response.data.config;
        })
        .catch( (err) => {
          self.handleAlert( err );
        })
        .finally( () => { self.setLoading(false); });
      },


      getKitData: async function(){

        var self = this;

        var endpoint = this.legacyApiUrl + 'kits/' + this.kitId;

        self.setLoading(true); 
        await axios.get(endpoint).then( ( response ) => {
          if( response.data.ok ){
              
              self.kit = response.data.data.kit;

          }

        } )
        .catch( ( error ) => {
          self.handleAlert( err );
        } )
        .finally( () => { self.setLoading(false); } );
        ;


      },




      getSchoolTypes: function(){
        // https://api.progettieducativi.it/api/v3/schoolclasses/types


        var self = this;
        var url = this.legacyApiUrl + 'schoolclasses/types'

        self.setLoading(true);

        axios.get(url).then( ( response ) => {
          if( response.data.data.groups )
            self.class_groups = response.data.data.groups;

          if( response.data.data.types )
            self.class_types = response.data.data.types;

        } )
        .catch( ( err ) => {
          self.handleAlert( err );
        } )
        .finally( () => { self.setLoading(false); } );
      },

      getLocationOptions: function( province ){
        var self = this;
        https://locations-api.dev.progettieducativi.it/api/v1/locations?province=ITC15&access_token=LOC_BN78FGHiH839X

        self.setLoading(true);
        
        var url = '';
        if( province ){
          url = self.legacyLocationsApiUrl + 'locations?province=' + province + '&access_token=LOC_BN78FGHiH839X';
        }
        else{
          url = self.legacyLocationsApiUrl + 'locations?type=province&access_token=LOC_BN78FGHiH839X';
        }
        

        axios.get(url).then( ( response ) => {

          if( response.data.locations ){
            if( province ){
              self.school_cities = response.data.locations;
            }
            else{
              self.school_provinces = response.data.locations;
            }
          }
          

        } )
        .catch( ( error ) => {
          self.handleAlert( error );
        } )
        .finally( () => { self.setLoading(false); } );
      },


      updateCities: function(){
        if( this.form_school?.district?.id)
          this.getLocationOptions(this.form_school.district.id);
      },

      resetSchoolForm: function(){
        this.school_form_enabled = false;

        this.form_school = {
          name: '',
          address: '',
          district: '',
          city: '',
          zip_code: '',
          email: '',
          phone: '',
          school_manager: '',

        };

      },

      
      userFind: function(){

        var self = this;
        this.current_alert = null;
        this.current_alert_type = null;

        self.setLoading(true);

        this.remote_api.client.post('/user/user-find', { email: this.form_login.email } )
        
        .then( (response) => {

          if( response.data.success ){
            
            self.user_found = response.data.user_found;

            if( response.data.user_found ){
              self.current_auth_state = 'login';
            }
            else{
              self.current_auth_state = 'register';
              self.show_password = false;
              self.form_register.email = self.form_login.email;
            }
              
          }
          
          if( response.data.validation  ){
            self.form_validation = response.data.validation;
          }
            
        })
        .catch( (err) => {
          self.handleAlert( err );
        })
        .finally( () => { self.setLoading(false); } );
        ;
      },




      userCheck: function(){

        var self = this;
        this.current_alert = null;

        self.setLoading(true);

        this.remote_api.client.get('/user/user-check')
        .then( (response) => {

          if( response.data.success && response.data.user ){
            
            self.current_user = response.data.user;
            self.user_found = true;
            self.gotoStep(1);
          }
            
        })
        .catch( (err) => {
          self.handleAlert( err );
        })
        .finally( () => { self.setLoading(false); } );
        ;
      },



      resetPassword: function(){
        
          var self = this;
          

          self.setLoading(true);

          this.remote_api.client.post('/user/user-reset-password', { email: self.form_login.email })
          .then( (response) => {

            if( response.data.success ){
              self.reset_password_confirmation = false;
              self.toast.success( 'Email inviata correttamente' );

              self.handleAlert('È stata inviata una mail all\'indirizzo email specificato con il link per reimpostare la password. Aprila e cliccaci sopra per procedere.', 'success');
            }
              
          })
          .catch( (err) => {
            self.handleAlert( err );
          })
          .finally( () => { self.setLoading(false); } );
          ;
        
      },

      
      submitLogin: function(){
        var self = this;

        this.current_alert = null;

        this.remote_api.client.post('/user/user-login', this.form_login )
        .then( (response) => {

          if( !response.data.success )
            self.handleAlert( response.data.message );  

          if( response.data.validation  ){
            self.form_validation = response.data.validation;
          }

          if( response.data.success && response.data.user ){
            self.current_user = response.data.user;
            self.remote_api = new RemoteApiService( this.remoteApiUrl, self.current_user.id, self.current_user.remote_token );
            self.gotoStep(1);
          }
            
        })
        .catch( (err) => {
          self.handleAlert( err );
        });
      },

      validateRegister: function(){
        var self = this;

        this.current_alert = null;

        this.remote_api.client.post('/user/user-validate-register', this.form_register )
        .then( (response) => {

          console.log(response.data);

          if( !response.data.success )
            self.handleAlert( response.data.message );  
          else
            self.gotoStep(1);

          if( response.data.validation  ){
            self.form_validation = response.data.validation;
          }

        })
        .catch( (err) => {
          self.handleAlert( err );
        });
      },


      submitRegister: function(){
        var self = this;

        this.current_alert = null;

        this.remote_api.client.post('/user/user-register', this.form_register )
        .then( (response) => {

          if( !response.data.success )
            self.handleAlert( response.data.message );  

          if( response.data.validation  ){
            self.form_validation = response.data.validation;
          }

          if( response.data.success && response.data.user ){
            self.current_user = response.data.user;
            self.remote_api = new RemoteApiService( this.remoteApiUrl, self.current_user.id, self.current_user.remote_token );
            self.gotoStep(4);
          }
            
        })
        .catch( (err) => {
          self.handleAlert( err );
        });
      },
      
      searchSchool:  _.debounce( function(){
          // https://v2.api.progettieducativi.it/api/v2/schools?q=galvani%20nova&access_token=undefined&0=%7B&1=%7D
          var self = this;
          
          if(this.school_search_string.length < 3 )
              return;
          
          self.setLoading(true)
          var url = this.legacySchoolsApiUrl + 'schools?q=' + this.school_search_string ;
          axios.get( url )
          .then( (response) => {
              if(response.data.data.schools){
                
                self.schools_found = response.data.data.schools;
              }
                
          })
          .catch( (error) => { 
              self.toast.error( 'Errore nella richiesta' );
          })
          .finally(() => self.setLoading(false));
      }, 250),

      selectSchool: function( school ){
          

          this.current_school = school;
          this.setSchoolSearchString()
          
          this.schools_found = [];

      },
      deselectSchool: function(){
          this.current_school = null;
          this.school_search_string = ''; 
      },

      submitSchoolForm: function(){


        this.current_school = {
          name: this.form_school.name,
          address: this.form_school.address,
          province_iso_code: this.form_school.district.name,
          city_name: this.form_school.city.name,
          postcode: this.form_school.zip_code,
          email: this.form_school.email,
          phone: this.form_school.phone,
          school_manager: this.form_school.school_manager,

          region: this.form_school.city.region.name,
          is_user_provided: true,
        };

        this.school_form_enabled = false;
        this.setSchoolSearchString();

      },

      setSchoolSearchString: function(){

        if(!this.current_school) {
            this.school_search_string = '';
        }
        else    
            this.school_search_string = this.getSchoolDescription(this.current_school);


      },
      getSchoolDescription: function(school){
        return '' + this.current_school?.name + ', ' +  this.current_school?.address + ' ' + this.current_school?.city_name + ' - (' + this.current_school.province_iso_code + ')'; 
      },

      addClass: function(){
        this.current_classes.push(
          {
            type: null,
            section: null,
            students_count: null,
          }
        );
      },

      removeClass: function( idx ){
        this.current_classes.splice(idx, 1);
      },

      closeOrder: async function(){

        var self = this;

        /*{
            "teacher_id": 1,
            "teacher_subject": "Tecnologia ed informatica",
            "teacher_first_name": "Utente",
            "teacher_last_name": "Test",
            "teacher_email": "utente@test.it",
            "teacher_phone": "0321456789",
            "teacher_city": "N/D",
            "teacher_province": "N/D",
            "teacher_ref_code": "",
            "extra_value_str": "/prenotazione-kit/|form/latest|kit(s):199",
            "extra_value_int": "",
            "school_id": "RGAA80601C"
          } 
        */

        var endpoint = this.legacyApiUrl + 'kit-orders?ref_kits=' + this.kitId;

        var extra_value_str = JSON.stringify({
          desk_user_id: this.current_user.id,
          source_url: window.location.href,
        });


        var  payload = {
              teacher_id: 1,
              teacher_subject: this.current_teaching_area,
              teacher_first_name: this.current_user.first_name,
              teacher_last_name: this.current_user.last_name,
              teacher_email:  this.current_user.email,
              teacher_phone:  this.current_user.phone ? this.current_user.phone : 'N/D',
              
              teacher_city: "N/D",
              teacher_province: "N/D",
              teacher_ref_code: "",

              extra_value_str: extra_value_str,
              extra_value_int: ""
        };

        if( this.current_school.is_user_provided ){
            payload.user_provided_school_school_type = "N/D";
            payload.user_provided_school_name = this.current_school.name;
            payload.user_provided_school_address = this.current_school.address;
            payload.user_provided_school_city = this.current_school.city;
            payload.user_provided_school_postcode = this.current_school.zip_code;
            payload.user_provided_school_zip_code = this.current_school.zip_code;
            payload.user_provided_school_province = "";
            payload.user_provided_school_region = this.current_school.region;
            payload.user_provided_school_phone = this.current_school.phone;
            payload.user_provided_school_fax = "";
            payload.user_provided_school_email = this.current_school.email;
            payload.user_provided_school_manager = this.current_school.school_manager;
          
        }
        else{
          payload.school_id = this.current_school.id;
        }

        self.setLoading(true); 
        await axios.post(endpoint, payload).then( ( response ) => {
          if( response.data.ok ){
              console.log('closeOrder', response.data);
              self.order_result.id = response.data.data.order_id;
              self.order_result.data = response.data.data.order

              self.sendOrderItems();
          }

        } )
        .catch( ( error ) => {
          self.handleAlert( err );
        } )
        .finally( () => { self.setLoading(false); } );
        ;
        
      },

      sendOrderItems: async function(){

        var self = this;
        var endpoint = this.legacyApiUrl + 'kit-orders/' + this.order_result.id + '/items';

        self.setLoading(true); 

        axios.all( this.current_classes.map( 
          function( cl ){

              //{"product_id":"199","schoolclass_type":"ELEM-1","schoolclass_schoolyear":"2024","schoolclass_sec":"A","schoolclass_num_students":"1"}

              var current_year = new Date().getFullYear();

              var payload = {
                product_id: self.kitId,
                schoolclass_type: cl.type,
                schoolclass_sec: cl.section,
                schoolclass_num_students: cl.students_count,
                schoolclass_schoolyear: current_year
              };

              return axios.post(endpoint, payload); 
          }
          )
        )
        .then( (results) => {
          for( var i in results){
            var res = results[i].data;
            self.order_result.items.push(res);
            
          }

          self.order_result.completed = true;
          // self.notifyOrder(); //20241217MB > la notifica la mandiamo da DESK!
          self.saveDeskOrder(); 


          var kit_event = new CustomEvent("kit-order-completed", { detail: { order_id: self.order_result.id } });
          
          window.dispatchEvent(kit_event);
          
        })
        .finally( () => { self.setLoading(false); } );
        ;
      },

      notifyOrder: async function(){

        var self = this;

        var endpoint = this.legacyApiUrl + 'kit-orders/' +  this.order_result.id + '/confirmations?teacher_email=' + this.current_user.email;

        await axios.post(endpoint).then( ( response ) => {
          if( response.data.ok ){
              console.log('notifyOrder', response.data);
          }
          else{
            // self.handleAlert(response.data.error);
            console.log('ERROR in notifyOrder', response.data);
          }

        } )
        .catch( ( err ) => {
          self.handleAlert( err, 'Impossibile inviare il messaggio di notifica all\'utente' );
        } )
        .finally( () => { self.setLoading(false); } );
        ;
      },

      saveDeskOrder: function(){

        // current_school
        // current_user
        // current_teaching_area
        
        // current_classes

        // order_result

        var post_data = {
          school: this.current_school,
          user: this.current_user,
          teaching_area: this.current_teaching_area,
          classes: this.current_classes,
          order: this.order_result,
          kit: this.kit,
        };

        var self = this;

        self.setLoading(true);

        self.remote_api.client.post('/user/save-kit-order', post_data)
        .then( (response) => {
          console.log('saveDeskOrder / save-kit-order', response.data);
        })
        .catch( (err) => {
          self.handleAlert( err );
        })
        .finally( () => { self.setLoading(false); });

      },




    },

    computed: {
      types_list: function(){
        return this.class_types;
      },
      schoolFormValid: function(){
        return (this.form_school.name != '') &&
                (this.form_school.address != '') &&
                (this.form_school.district != '') &&
                (this.form_school.city != '') &&
                (this.form_school.zip_code != '') &&
                (this.form_school.name != '') &&
                (this.form_school.email != '') &&
                (this.form_school.phone != '') &&
                (this.form_school.school_manager != '');
      },
      classesValid: function(){
        var result = true;

        if( this.current_classes.length == 0 )
          return false;

        for( var i in this.current_classes ){
          var c = this.current_classes[i];
          if( !c.type || !c.section || !c.students_count  )
            return false;
        }

        return result;
      },
    }
  }
  